(function () {
   'use strict';

   module.exports = AssetCoreClient;
   var logger = new (require('../helpers/logger.js'))("AssetCoreClient").setColor("rgb(214, 106, 37)").setDebug(true);
   var helper = require('../helpers/generic.js');
   var acHelper = require('./helper.js');
   var settings = require('../helpers/settings.js');
   var jquery = require('jquery');

   var paths = {
     detailsForCode: function(code){
       return 'Asset/info?code=' + code;
     }
   };

   function AssetCoreClient(baseUrl){
     if (helper.undefOrNull(baseUrl)){
        baseUrl = settings.getAssetCoreBaseUrl();
     } else {
       settings.setAssetCoreBaseUrl(baseUrl);
     }
     logger.debug("Initialising AssetCoreClient with baseUrl '"+baseUrl+"'");
     if (helper.undefOrNull(baseUrl)){
       throw "AssetCoreClient: baseUrl must be set (is "+baseUrl+")!";
     }
     this.baseUrl = baseUrl;
   }

   AssetCoreClient.prototype = {
     getMediaPromise: function getMediaPromise(mediaCodeOrUrl){
       var deferred = jquery.Deferred();
       var promise = deferred.promise();
       if (helper.undefOrNull(mediaCodeOrUrl)){
         deferred.resolve(null);
       } else {
         // urls: ../a.jpg, ./a.jpg, /a.jpg, http://www.xyz.de/a.jpg, https://www.xyz.de/a.jpg BUT NOT if it matches the code regex
         var isUrl = (mediaCodeOrUrl.startsWith("http") || mediaCodeOrUrl.startsWith(".") || mediaCodeOrUrl.startsWith("/"));
         var containsAssetCode = acHelper.getCodeRegex().test(mediaCodeOrUrl);
         var isPosterUrl = isUrl && mediaCodeOrUrl.indexOf('poster=true')>0;

         if (isUrl && (!containsAssetCode || isPosterUrl)){
           logger.debug("Media is URL: ", mediaCodeOrUrl);
           deferred.resolve(mediaCodeOrUrl);
         } else {
           logger.debug("Media is AssetCoreMedia: ", mediaCodeOrUrl);
           promise = this.detailsForCode(mediaCodeOrUrl);
         }

       }

       return promise;
     },
     _detailsForCode: function _detailsForCode(code){
       code = acHelper.getCode(code);
       var url = this._getAssetCoreUrl(paths.detailsForCode(code));
       var deferred = jquery.Deferred();

       jquery.get(url).done(function(details, statusText, xhr){
         deferred.resolve( acHelper.fromDetailJson(details) );
       }).fail(function(xhr, textStatus, errorThrown){
         if (xhr.status==404){
            logger.debug("assetInfo failed: asset with code not found");
            deferred.reject("An Asset with Code '"+code+"' could not be found!");
         } else {
            logger.debug("assetInfo failed: ", data.statusText);
            deferred.reject("Error getting details for code '"+code+"' from url '"+url+"': " + data.statusText);
         }
       });

       return deferred.promise();
     },
     _getAssetCoreUrl: function _getAssetCoreUrl(path){
       var pathSep = "/";
       var base = this.baseUrl;
       var url;
       if (base.endsWith(pathSep) && path.startsWith(pathSep)){
         url = base.substring(0, base.length-1) + path;
       } else if (!base.endsWith(pathSep) && !path.startsWith(pathSep)){
         url = base + pathSep + path;
       } else {
         url = base + path;
       }
       return base + path;
     },
     detailsForCode: function detailsForCode(code){
       return this._detailsForCode(code);
     }
  };


}());



//////////////////
// WEBPACK FOOTER
// ./src/AssetCore/client.js
// module id = 5
// module chunks = 0